import AbortService from "@rmp/core/services/abortService";
import BaseOrganizationController from "@rmp/core/api/base/baseOrganizationController";
import { withCaptcha } from "@rmp/core/services/captcha";

export class LegalPersonController extends BaseOrganizationController {
	constructor(private readonly abortService: AbortService) {
		super(abortService);
	}

	updateLegalPersonCounterpartyEmployee = this.api.counterparty.entrepreneurEmployeeUpdateByEmployeeId
	updateOwnLegalPersonCounterpartyEmployee = this.api.own.counterpartyEntrepreneurEmployeeUpdateByEmployeeId

	createLegalPersonCounterpartyEmployee = this.api.counterparty.entrepreneurEmployeeCreateByCounterpartyId
	createOwnLegalPersonCounterpartyEmployee = this.api.own.counterpartyEntrepreneurEmployeeCreateByAssignToAccount

	getSuggestion = withCaptcha(this.api.counterparty.entrepreneurSuggestionCompleteListByInn, () => this.abortService.getSignal());

	checkAccountExists = this.api.counterparty.entrepreneurCheckAccountExistsCreate

	getLegalPersonByInnOgrn = this.api.counterparty.entrepreneurSearchListByInn

	checkLegalPersonIsExists = this.api.counterparty.entrepreneurExistsListByInn

	getEntrepreneurMasterAccountProfile = this.api.counterparty.entrepreneurProfileListByEntrepreneurId

	checkMasterAccount = this.api.counterparty.entrepreneurProfileCheckCreate

	createEntrepreneurMasterAccountProfile = this.api.counterparty.entrepreneurProfileCreateByEntrepreneurId

	updateEntrepreneurMasterAccountProfile = this.api.counterparty.entrepreneurProfileUpdateByEntrepreneurId
}
